import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { ReleaseRegressionScreen } from "../../features/releases/release-regression-screen";

export function createReleasesRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "releases",
    element: <ReleaseRegressionScreen dependencies={dependencies} />,
  };
}
